import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import actions from "../actions/actions";
import { showToast } from "../components/toast";

export function useLazySelector(selector, loader) {
  let result = useSelector(selector);
  useEffect(() => {
    if (result === undefined)
      loader();
  }, []);
  return result;
}

export function useOnFirstLoad(action) {
  useEffect(action, []);
}

export function useLogoutIfAccessDisabled(loginUser) {
  useEffect(() => {
    if (loginUser && loginUser?.allow_login === false) {
      showToast("error", "Access is disabled. You have been logged out.");
      actions.user.logout();
    }
  }, [loginUser, loginUser?.allow_login]);
}